import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from '@app/components/components.module';
import { RouterModule } from '@angular/router';
import { IconsModule } from '@app/app-icons.module';
import { StylesModule } from '@app/styles/styles.module';
import { CustomersListComponent } from './customers-list/customers-list.component';
import { AddCustomerComponent } from './add-customer/add-customer.component';
import { SidebarModule } from 'primeng/sidebar';


@NgModule({
  declarations: [
    CustomersListComponent,
    AddCustomerComponent
  ],
  exports: [
    AddCustomerComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    ComponentsModule,
    IconsModule,
    StylesModule,
    FormsModule,
    ReactiveFormsModule,
    SidebarModule
  ]
})
export class CustomersModule { }
